import { useState, useCallback } from "react";
import { Button } from "@constructorfleet/ui/design-system";
import { Modal } from "@constructorfleet/ui";

export function useConfirmAction() {
  const [pending, setPending] = useState<{
    title: string;
    message: string;
    confirmLabel: string;
    tone: "danger" | "neutral";
    onConfirm: () => void;
  } | null>(null);

  const requestConfirm = useCallback(
    (opts: {
      title: string;
      message: string;
      confirmLabel?: string;
      tone?: "danger" | "neutral";
      onConfirm: () => void;
    }) => {
      setPending({
        title: opts.title,
        message: opts.message,
        confirmLabel: opts.confirmLabel ?? "Confirm",
        tone: opts.tone ?? "danger",
        onConfirm: opts.onConfirm,
      });
    },
    []
  );

  const confirmModal = pending ? (
    <Modal
      open
      title={pending.title}
      onClose={() => setPending(null)}
      actions={
        <Button
          type="button"
          className={pending.tone === "danger" ? "btn-danger" : undefined}
          onClick={() => {
            pending.onConfirm();
            setPending(null);
          }}
        >
          {pending.confirmLabel}
        </Button>
      }
    >
      <p>{pending.message}</p>
    </Modal>
  ) : null;

  return { requestConfirm, confirmModal };
}
